import React, { useEffect, useRef, useState } from 'react';
import { api } from '../../components/api/api';
import { Alert, Pergunta, AlertErro } from '../../util/Alertas';
import BloquearClientesTable from './bloquearClientesTable';
import { ImLock } from 'react-icons/im';
import { FaSearch } from 'react-icons/fa';
import ReactInputMask from 'react-input-mask';
import BloquearClientesModal from './BloquearClientesModal';

function BloquearClientes() {
    const bloquearClientesModalRef = useRef();
    const [clientes, SetClientes] = useState([]);
    const [filtroNome, setFiltroNome] = useState("");
    const [dataInicio, setDataInicio] = useState("");
    const [dataFim, setDataFim] = useState("");
    const [nPedido, setNPedido] = useState("");

    const BuscarClientesBloqueados = () => {
        api.get(`BloqueioPedido?nome=${filtroNome}&pedidoId=${nPedido}&dateInicio=${dataInicio}&dateFim=${dataFim}`, res => {
            SetClientes(res.data);
        }, err => {
            AlertErro(err, 'Erro ao buscar os clientes bloqueados')
        })
    }

    useEffect(() => {
        BuscarClientesBloqueados();
    }, [])

    const Desbloquear = async (clientId, nome) => {
        if (await Pergunta("Deseja realmente desbloquear o " + nome)) {
            api.post(`/BloqueioPedido/Desbloquear/${clientId}`, {}, res => {
                BuscarClientesBloqueados();
                Alert(`${nome} desbloqueado com sucesso!`);
            }, err => {
                AlertErro(err, `Erro ao desbloquear o cliente ${nome}`);
            })
        }
    }

    return (
        <div className="content">
            <BloquearClientesModal
                ref={bloquearClientesModalRef}
                reload={BuscarClientesBloqueados}
                Desbloquear={Desbloquear}
            />
            <div
                className="row"
                style={{
                    padding: '1rem',
                    background: 'var(--cor-principal)',
                    color: '#fff',
                    width: '100%',
                    margin: '0'
                }}
            >
                <div className="col-12 mb-3">
                    <label>Filtros:</label>
                </div>

                <div className='col-12' style={{ display: 'flex', width: '100%', justifyContent: 'end', alignItems: 'center' }}>
                    <button
                        className="btn btn-success"
                        style={{ display: 'flex', alignItems: 'center', gap: 10 }}
                        onClick={() => bloquearClientesModalRef.current.show()}
                    >
                        Novo Bloqueio <ImLock />
                    </button>
                </div>

                <form
                    className="col-12"
                    onSubmit={(e) => {
                        e.preventDefault();
                        BuscarClientesBloqueados();
                    }}
                >
                    <div className="row g-2">
                        <div className="col-md-6">
                            <label className="form-label">Nome do Cliente</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Nome do cliente"
                                value={filtroNome}
                                onChange={(e) => setFiltroNome(e.target.value)}
                            />
                        </div>

                        <div className="col-md-3">
                            <label className="form-label">Data Bloqueio De:</label>
                            <input
                                type="date"
                                className="form-control"
                                value={dataInicio}
                                onChange={(e) => setDataInicio(e.target.value)}
                            />
                        </div>

                        <div className="col-md-3">
                            <label className="form-label">Até:</label>
                            <input
                                type="date"
                                className="form-control"
                                value={dataFim}
                                onChange={(e) => setDataFim(e.target.value)}
                            />
                        </div>

                        <div className='col-12' style={{ display: 'flex', width: '100%', justifyContent: 'end', alignItems: 'center' }}>
                            <button type="submit" className="btn btn-primary w-100">
                                Buscar <FaSearch />
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            <BloquearClientesTable
                clientes={clientes}
                filtroNome={filtroNome}
                Desbloquear={Desbloquear}
            />
        </div>
    );
}

export default BloquearClientes;